import { GET_CHECKBOOK_EMITED } from './../constants';
import { handleActions } from "redux-actions"

export const checkbookEmited  = handleActions(
  {
    [ GET_CHECKBOOK_EMITED ]: (state, action) =>[ ...action.payload ],

  }, []
)